<ng-content></ng-content>
<a class="type-toggle" (click)="toggleShow()">
   <ion-icon class="show-option" [hidden]="!showPassword" color="medium" name="eye-off-outline"></ion-icon>
   <ion-icon class="hide-option" [hidden]="showPassword" color="primary" name="eye-outline"></ion-icon>
</a> 